import { useSyncExternalStore } from "react";
import { useIsMutating, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api, type AppState } from "../../api";
import { useCommand } from "../data/useCommand";
export type Appearance = { theme: "light" | "dark" | null; money_colors: boolean; revision: number };
const subscribe = (notify:()=>void) => { window.addEventListener("estet:viewport",notify); return ()=>window.removeEventListener("estet:viewport",notify); };
const currentTheme = () => document.documentElement.dataset.nextTheme === "dark" ? "dark" : "light";
export function useAppearance(user: AppState, enabled = true) {
  const cache=useQueryClient(), command=useCommand();
  const key=["preferences",user.user_id];
  const appearance=useQuery({queryKey:key,queryFn:()=>api<Appearance>("preferences"),enabled});
  const mutationKey=["appearance",user.user_id];
  const mutation=useMutation({mutationKey,mutationFn:async(value:Partial<Pick<Appearance,"theme"|"money_colors">>)=>{
    const latest=cache.getQueryData<Appearance>(key);
    if(!latest)throw Error("Настройки оформления ещё не загружены.");
    const next=await command.command<Appearance>("preferences",{action:"appearance",...latest,...value});
    cache.setQueryData(key,next);
    return next;
  }});
  const busy=useIsMutating({mutationKey})>0;
  const theme=useSyncExternalStore(subscribe,currentTheme,currentTheme);
  return {appearance,busy,theme,error:mutation.error instanceof Error?mutation.error.message:"", apply:async(value:Partial<Pick<Appearance,"theme"|"money_colors">>)=>{if(busy)return;try{await mutation.mutateAsync(value);}catch{/* Render the error beside controls; never claim persistence. */}}};
}
